<p-card>
  <ng-template pTemplate="content">
    <p-fileUpload
      #fileUpload
      [customUpload]="true"
      [multiple]="allowMultiple"
      [accept]="acceptedFileTypes"
      [showUploadButton]="false"
      [showCancelButton]="false"
      (onSelect)="onFileSelect($event)"
      (onRemove)="onFileRemove($event)"
      (onClear)="onClear()"
      [auto]="false">

      @if (showClearAction || showUploadAction || showChooseAction) {
        <ng-template pTemplate="header" let-chooseCallback="chooseCallback" let-clearCallback="clearCallback">
          <div class="d-flex flex-wrap justify-content-between align-items-center gap-2">
            <div class="flex gap-2">
              @if (showChooseAction) {
                <p-button (onClick)="chooseCallback()"
                  icon="pi pi-file"
                  size="small"
                  label="{{'IBP_IMAGE_UPLOAD.CHOOSE_FILES_BUTTON_LABEL' | translate}}"
                  [disabled]="uploading">
                </p-button>
              }
              @if (showUploadAction) {
                <p-button (onClick)="uploadFiles()"
                  icon="pi pi-cloud-upload"
                  size="small"
                  label="{{'IBP_IMAGE_UPLOAD.UPLOAD_BUTTON_LABEL' | translate}}"
                  [disabled]="!hasFiles || uploading"
                  [loading]="uploading">
                </p-button>
              }
              @if (showClearAction) {
                <p-button (onClick)="clearCallback()"
                  icon="pi pi-times"
                  size="small"
                  label="{{'IBP_IMAGE_UPLOAD.CLEAR_BUTTON_LABEL' | translate}}"
                  [disabled]="!hasFiles || uploading"
                  severity="secondary">
                </p-button>
              }
            </div>
            @if (selectedFiles.length > 0) {
              <p-badge
                [value]="selectedFiles.length.toString()"
                severity="info">
              </p-badge>
            }
          </div>
        </ng-template>
      }
      <ng-template pTemplate="content">
        @if (selectedFiles.length > 0) {
          <div class="mt-3">
            <div class="d-flex flex-column gap-3">
              @for (file of selectedFiles; track $index; let i = $index) {
                <div
                  class="d-flex col-12 p-0 m-0 align-items-center flex-wrap py-3 border-1 justify-content-between">
                  <div class="d-flex col-10 p-0 m-0 align-items-center flex-1">
                    <i class="col-1 p-0 m-0 pi pi-file text-primary"></i>
                    <div class="col-11 p-0 m-0 d-flex flex-column text-left">
                      <span class="col-12 p-0 m-0 pb-1 font-weight-bold p-upload-text">{{ file.name }}</span>
                      <small class="col-12 p-0 m-0 p-upload-text">{{ formatFileSize(file.size) }}</small>
                    </div>
                  </div>
                  <div class="col-2 p-0 m-0">
                    <p-button icon="pi pi-times"
                      severity="danger"
                      [size]="'small'"
                      (onClick)="removeFile(i)"
                      [disabled]="uploading">
                    </p-button>
                  </div>
                </div>
              }
            </div>
          </div>
        }
        @if (selectedFiles.length === 0) {
          <div class="d-flex flex-column align-items-center justify-content-center p-6 border-2 text-center">
            <i class="pi pi-cloud-upload font-lg mb-3"></i>
            <p class="font-lg mb-2">{{ 'IBP_IMAGE_UPLOAD.DRAG_AND_DROP_INFO' | translate }}</p>
            <p
            class="font-sm">{{ 'IBP_IMAGE_UPLOAD.DRAG_AND_DROP_SUPPORTED_FORMATS_INFO' | translate : {maxFileSize: formatFileSize(maxFileSize)} }}</p>
          </div>
        }
      </ng-template>

      <ng-template pTemplate="file" let-file let-index="index">
        <!-- This template is not used when showUploadButton is false -->
      </ng-template>
    </p-fileUpload>

    @if (uploading) {
      <div class="mt-3">
        <p-progressBar [value]="uploadProgress" [showValue]="true"></p-progressBar>
        <p class="text-center font-sm mt-2">{{ 'IBP_IMAGE_UPLOAD.UPLOADING_INFO' | translate }}</p>
      </div>
    }

    @if (uploadedDocuments.length > 0) {
      <div class="mt-4">
        <h4 class="font-lg font-weight-bold mb-3">{{ 'IBP_IMAGE_UPLOAD.UPLOADED_HEADER' | translate }}</h4>
        <div class="d-flex flex-column gap-2">
          @for (doc of uploadedDocuments; track doc.id) {
            <div class="d-flex align-items-center justify-content-between p-2 border-1">
              <div class="d-flex align-items-center gap-2">
                <i class="pi pi-file-check"></i>
                <span class="font-medium p-upload-text">{{ doc.filename }}</span>
                <small class="font-sm p-upload-text">({{ formatFileSize(doc.size) }})</small>
              </div>
              <small class="font-sm p-upload-text">{{ formatDate(doc.uploadDate) }}</small>
            </div>
          }
        </div>
      </div>
    }
  </ng-template>
</p-card>
